import { ru, type TranslationKey } from './ru';

export type { TranslationKey };

export type Locale = 'ru';

const DICTIONARIES: Record<Locale, Record<string, string>> = { ru };

let activeLocale: Locale = 'ru';

export function setLocale(locale: Locale): void {
  activeLocale = locale;
}

export function getLocale(): Locale {
  return activeLocale;
}

export type TranslationParams = Record<string, string | number>;

/**
 * Translate a key, substituting `{name}` placeholders.
 *
 * A missing key returns the key itself rather than throwing: a broken string is
 * a visible bug, but it must never take a training session down mid-exercise.
 */
export function t(key: TranslationKey, params?: TranslationParams): string {
  const dictionary = DICTIONARIES[activeLocale];
  const template = dictionary[key] ?? key;
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) => {
    const value = params[name];
    return value === undefined ? match : String(value);
  });
}

/** Russian plural forms: 1 аккорд, 2 аккорда, 5 аккордов. */
export function plural(count: number, one: string, few: string, many: string): string {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

export function minutesLabel(count: number): string {
  return `${count} ${plural(count, 'минута', 'минуты', 'минут')}`;
}
